<template>
    <div class="main-wrap">
        <template v-if="userIsAuth == 'p' || userIsAuth == 'n' || userIsAuth == 'y'">
            <div class="item">
                <div class="label">法定负责人</div>
                <div class="content">
                    <div class="text">{{userInfo.companyKeyPerson}}</div>
                </div>
                <div class="btn-wrap"></div>
            </div>
            <div class="item">
                <div class="label">公司电话</div>
                <div class="content">
                    <div class="text">{{userInfo.companyPhone}}</div>
                </div>
                <div class="btn-wrap"></div>
            </div>
            <div class="item">
                <div class="label">公司地址</div>
                <div class="content">
                    <div class="text">{{userInfo.addressStr}}</div>
                </div>
                <div class="btn-wrap">
                </div>
            </div>
            <div class="item">
                <div class="label">公司实拍照片</div>
                <div class="content">
                    <el-image 
                        v-for="url in companyImage" :key="url"
                        style="width: 100px; height: 100px; border: 1px solid #ddd;margin-right: 10px"
                        :src="url"
                        @click="dialogImageUrl = url; imageVisible = true"
                    >
                    </el-image>
                    <el-dialog title="查看图片" width="600px" :visible.sync="imageVisible">
                        <img style="width: 100%;" :src="dialogImageUrl" alt="">
                    </el-dialog>
                </div>
                <div class="btn-wrap"></div>
            </div>

        </template>
        
        <div class="item">
            <div class="label">您擅长加工的品类</div>
            <div class="content">
                <div class="cate-text">
                    <template  v-for="(item, index) in userInfo.mainTypeLists" >
                        <div class="cate-line" :key="item.dataName + index" v-if="item.checked">
                            <p class="cate-lab">{{item.dataName}}</p> 
                            <p class="cate-con">
                                <template v-for="(ele, i) in item.list">
                                    <span :key="ele.name + i" v-if="ele.checked">{{ele.name}}</span>
                                </template>
                            </p>
                        </div>
                    </template>
                </div>
            </div>
            <div class="btn-wrap">
                <i class="icon-edit" @click="editFormHandle('clothesData')"></i>
            </div>
        </div>
        <el-dialog title="选择您擅长加工的品类" :visible.sync="editForm.clothesData" width="900px" class="dialog-header-border">
            <div class="cate-pop">
                <el-form :model="submitForm" ref="clothesData">
                    <el-form-item prop="clothesData"
                        :rules="[
                            { validator: validateClothesData},
                        ]"
                    >
                        <div class="cate-line" v-for="(item, index) in submitForm.clothesData" :key="item.dataName + index">
                            <strong class="cate-lab">{{item.dataName}}</strong>
                            <div class="cate-select w">
                                <el-checkbox :label="ele.name"
                                    v-for="(ele, i) in item.list" :key="ele+i"
                                    v-model="ele.checked"
                                    @change="changeClothesTag"
                                ></el-checkbox>
                            </div>
                        </div>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editForm.clothesData = false">取 消</el-button>
                <el-button type="primary" @click="submitFormHandle('clothesData')">确 定</el-button>
            </div>
        </el-dialog>
        
        <div class="item">
            <div class="label">您所能处理的加工环节</div>
            <div class="content">
                <div class="text" v-if="!editForm.handleNeedProcessingLink">
                    <template v-for="(item, index) in userInfo.handleNeedProcessingLink.list">
                        <span style="margin-right: 16px" v-if="item.isSelect == 1" :key="index">
                            {{item.dataName}}
                        </span>
                    </template>
                    <span v-if="userInfo.handleNeedProcessingLink.other">
                        {{userInfo.handleNeedProcessingLink.other}}
                    </span>
                </div>
                <div class="edit-box" v-else>
                    <el-form :model="submitForm" ref="handleNeedProcessingLink">
                        <el-form-item
                            prop="handleNeedProcessingLink"
                            :rules="[
                                { validator: validateHandleNeedProcessingLink},
                            ]"
                        >
                            <el-checkbox 
                                :label="item.dataName"
                                :checked="item.isSelect == 1"
                                v-for="(item,index) in submitForm.handleNeedProcessingLink.list" :key="item.dataName + index"
                                @change="(e) => selectHandleNeedProcessingLink(e, item) "
                            ></el-checkbox>
                            <el-input v-model="submitForm.handleNeedProcessingLink.other" size="small"
                                style="width: 200px; margin-left: 30px;"
                                placeholder="(选填)请输入其他加工环节"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="submitFormHandle('handleNeedProcessingLink')">保存</el-button>
                            <el-button size="small" @click="editForm.handleNeedProcessingLink = false">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="btn-wrap">
                <i class="icon-edit" @click="editFormHandle('handleNeedProcessingLink')"></i>
            </div>
        </div>

        <div class="item">
            <div class="label">您所能处理的特殊工艺</div>
            <div class="content">
                <div class="text" v-if="!editForm.handleSpecialProcess">
                    <template v-for="(item, index) in userInfo.handleSpecialProcess.list">
                        <span style="margin-right: 16px" v-if="item.isSelect == 1" :key="index">
                            {{item.dataName}}
                        </span>
                    </template>
                    <span v-if="userInfo.handleSpecialProcess.other">
                        {{userInfo.handleSpecialProcess.other}}
                    </span>
                </div>
                <div class="edit-box" v-else>
                    <el-form :model="submitForm" ref="handleSpecialProcess">
                        <el-form-item
                            prop="handleSpecialProcess"
                            :rules="[
                                { validator: validateHandleSpecialProcess},
                            ]"
                        >
                            <el-checkbox 
                                :label="item.dataName"
                                :checked="item.isSelect == 1"
                                v-for="(item,index) in submitForm.handleSpecialProcess.list" :key="item.dataName + index"
                                @change="(e) => selectHandleSpecialProcess(e, item) "
                            ></el-checkbox>
                            <el-input v-model="submitForm.handleSpecialProcess.other" size="small"
                                style="width: 200px; margin-left: 30px;"
                                placeholder="(选填)请输入其他特殊工艺"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="submitFormHandle('handleSpecialProcess')">保存</el-button>
                            <el-button size="small" @click="editForm.handleSpecialProcess = false">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="btn-wrap">
                <i class="icon-edit" @click="editFormHandle('handleSpecialProcess')"></i>
            </div>
        </div>

        <div class="item">
            <div class="label">您的主要品质产出</div>
            <div class="content">
                <div class="text" v-if="!editForm.mainQuantityStr">
                    <template v-for="(item, index) in userInfo.mainQuantityStr.list">
                        <span style="margin-right: 16px" v-if="item.isSelect == 1" :key="index">
                            {{item.dataName}}
                        </span>
                    </template>
                    <span v-if="userInfo.mainQuantityStr.other">
                        {{userInfo.mainQuantityStr.other}}
                    </span>
                </div>
                <div class="edit-box" v-else>
                    <el-form :model="submitForm" ref="mainQuantityStr">
                        <el-form-item
                            prop="mainQuantityStr"
                            :rules="[
                                { validator: validateMainQuantityStr},
                            ]"
                        >
                            <el-radio-group v-model="qualitySelect">
                                <el-radio 
                                    :label="item.dataName"
                                    v-for="(item,index) in submitForm.mainQuantityStr.list" :key="item.dataName + index"
                                    @change="(e) => selectMainQuantityStr(e, item) "
                                ></el-radio>
                            </el-radio-group>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="submitFormHandle('mainQuantityStr')">保存</el-button>
                            <el-button size="small" @click="editForm.mainQuantityStr = false">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="btn-wrap">
                <i class="icon-edit" @click="editFormHandle('mainQuantityStr')"></i>
            </div>
        </div>

        <div class="item">
            <div class="label">您是否有采购面辅料的能力</div>
            <div class="content">
                <div class="text" v-if="!editForm.canBuyFabricAbility">
                    {{userInfo.canBuyFabricAbility ? '是' : '否'}}
                </div>
                <div class="edit-box" v-else>
                    <el-form :model="submitForm" ref="canBuyFabricAbility">
                        <el-form-item>
                            <el-switch
                                v-model="submitForm.canBuyFabricAbility"
                            >
                            </el-switch>
                            <span style="margin-left: 16px">{{submitForm.canBuyFabricAbility ? '是' : '否'}}</span>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="submitFormHandle('canBuyFabricAbility')">保存</el-button>
                            <el-button size="small" @click="editForm.canBuyFabricAbility = false">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="btn-wrap">
                <i class="icon-edit" @click="editFormHandle('canBuyFabricAbility')"></i>
            </div>
        </div>

        <div class="item">
            <div class="label">产能</div>
            <div class="content">
                <div class="text" v-if="!editForm.capcity">
                    {{userInfo.capcity || '未填写'}}
                </div>
                <div class="edit-box" v-else>
                    <el-form :model="submitForm" ref="capcity">
                        <el-form-item>
                           <el-input v-model="submitForm.capcity" size="small"
                                placeholder="例如:1000件/天"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="submitFormHandle('capcity')">保存</el-button>
                            <el-button size="small" @click="editForm.capcity = false">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="btn-wrap">
                <i class="icon-edit" @click="editFormHandle('capcity')"></i>
            </div>
        </div>

        <div class="item">
            <div class="label">意向接单区域</div>
            <div class="content">
                <div class="text" v-if="!editForm.favoriteArea">
                    {{userInfo.favoriteArea || '未填写'}}
                </div>
                <div class="edit-box" v-else>
                    <el-form :model="submitForm" ref="favoriteArea">
                        <el-form-item>
                           <el-input v-model="submitForm.favoriteArea" size="small"
                                placeholder="例如:杭州市余杭区"
                            ></el-input>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" size="small" @click="submitFormHandle('favoriteArea')">保存</el-button>
                            <el-button size="small" @click="editForm.favoriteArea = false">取消</el-button>
                        </el-form-item>
                    </el-form>
                </div>
            </div>
            <div class="btn-wrap">
                <i class="icon-edit" @click="editFormHandle('favoriteArea')"></i>
            </div>
        </div>

        <div class="fac-table-wrap">
            <div class="title-wrap">
                <span class="tit">员工人数</span>
                <el-button size="small" @click="editFormHandle('employeeData')">编辑</el-button>
            </div>
            <div class="table-container">
                <table class="table">
                    <tr>
                        <th>总人数</th>
                        <th v-if="userInfo.employeeData.childrenLists.length == 0">
                            岗位（待填写）
                        </th>
                        <template v-else>
                            <th v-for="(item, index) in userInfo.employeeData.childrenLists" :key="index">
                                {{item.name}}
                            </th>
                        </template>
                        
                    </tr>
                    <tr>
                        <td>{{userInfo.employeeData.total || '人数（待填写）'}}</td>
                        <td v-if="userInfo.employeeData.childrenLists.length == 0">
                            人数（待填写）
                        </td>
                        <template v-else>
                            <td v-for="(item, index) in userInfo.employeeData.childrenLists" :key="index">
                                {{item.num}}
                            </td>
                        </template>
                    </tr>
                </table>
            </div>
        </div>

        <el-dialog title="编辑员工人数" :visible.sync="editForm.employeeData" width="530px" class="dialog-header-border"
            :close-on-click-modal="false"
        >
            <div class="edit-table-wrap">
                <el-form :model="submitForm" ref="employeeData">
                    <el-form-item prop="employeeData"
                        :rules="[
                            { validator: validateEmployeeData},
                        ]"
                    >   
                    <div style="display: flex; justify-content: space-between; margin-bottom: 24px">
                            <span>
                                员工总人数:
                                <el-input-number size="small" v-model="submitForm.employeeData.total" controls-position="right" :min="1" :max="99999999" placeholder="请输入人数"></el-input-number>
                            </span>
                                
                            <el-button icon="el-icon-plus" size="small" @click="addEmployeeData">新增岗位</el-button>
                        </div>
                        
                        <table class="edit-table">
                            <tr>
                                <th width="200">岗位名称</th>
                                <th width="200">员工人数</th>
                                <th>操作</th>
                            </tr>
                            <tr v-for="(item, index) in employeeDataList" :key="item.key">
                                <td>
                                    <el-input size="small" v-model="item.name" placeholder="请输入岗位名称" />
                                </td>
                                <td>
                                    <el-input-number size="small" v-model="item.num" controls-position="right" :min="0" :max="99999999" 
                                    :precision="0"
                                    placeholder="请输入人数"
                                ></el-input-number>
                                </td>
                                <td>
                                    <el-button icon="el-icon-delete" circle size="small" @click="delEmployeeData(item, index)"></el-button>
                                </td>
                            </tr>
                        </table>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editForm.employeeData = false">取 消</el-button>
                <el-button type="primary" @click="editNumFormHandle('employeeData')">确 定</el-button>
            </div>
        </el-dialog>

        <div class="fac-table-wrap">
            <div class="title-wrap">
                <span class="tit">设备数（台）</span>
                <el-button size="small" @click="editFormHandle('machineData')">编辑</el-button>
            </div>
            <div class="table-container">
                <table class="table">
                    <tr>
                        <th>设备总数</th>
                        <th v-if="userInfo.machineData.childrenLists.length == 0">
                            设备名称（待填写）
                        </th>
                        <template v-else>
                            <th v-for="(item, index) in userInfo.machineData.childrenLists" :key="index">
                                {{item.name}}
                            </th>
                        </template>
                        
                    </tr>
                    <tr>
                        <td>{{userInfo.machineData.total || '设备数（待填写）'}}</td>
                        <td v-if="userInfo.machineData.childrenLists.length == 0">
                            设备数（待填写）
                        </td>
                        <template v-else>
                            <td v-for="(item, index) in userInfo.machineData.childrenLists" :key="index">
                                {{item.num}}
                            </td>
                        </template>
                    </tr>
                </table>
            </div>
        </div>

        <el-dialog title="编辑设备数" :visible.sync="editForm.machineData" width="530px" class="dialog-header-border"
            :close-on-click-modal="false"
        >
            <div class="edit-table-wrap">
                <el-form :model="submitForm" ref="machineData">
                    <el-form-item prop="machineData"
                        :rules="[
                            { validator: validateMachineData},
                        ]"
                    >   
                    <div style="display: flex; justify-content: space-between; margin-bottom: 24px">
                            <span>
                                设备总数:
                                <el-input-number size="small" v-model="submitForm.machineData.total" 
                                controls-position="right" :min="1" :max="99999999" placeholder="请输入数量"
                            ></el-input-number>
                            </span>
                                
                            <el-button icon="el-icon-plus" size="small" @click="addMachineData">新增设备</el-button>
                        </div>
                        
                        <table class="edit-table">
                            <tr>
                                <th width="200">设备名称</th>
                                <th width="200">设备数</th>
                                <th>操作</th>
                            </tr>
                            <tr v-for="(item, index) in machineDataList" :key="item.key">
                                <td>
                                    <el-input size="small" v-model="item.name" placeholder="请输入设备名称" />
                                </td>
                                <td>
                                    <el-input-number size="small" v-model="item.num" controls-position="right" :min="0" :max="99999999" 
                                    :precision="0"
                                    placeholder="请输入数量"
                                ></el-input-number>
                                </td>
                                <td>
                                    <el-button icon="el-icon-delete" circle size="small" @click="delMachineData(item, index)"></el-button>
                                </td>
                            </tr>
                        </table>
                    </el-form-item>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button @click="editForm.machineData = false">取 消</el-button>
                <el-button type="primary" @click="editNumFormHandle('machineData')">确 定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import api from '@/api'
import request from '@/utils/request'
import { mapGetters } from 'vuex'
import areaPicker from '@/components/areaPicker.vue'

export default {
    components: {
        areaPicker
    },
    data() {
        return {
            // 图片预览
            imageVisible: false,
            dialogImageUrl: '',

            editForm: {
                clothesData: false,
                handleNeedProcessingLink: false,
                handleSpecialProcess: false,
                mainQuantityStr: false,
                canBuyFabricAbility: false,
                capcity: false,
                favoriteArea: false,
                employeeData: false,
                machineData: false,
            },
            submitForm: {
                clothesData: [], // 品类
                handleNeedProcessingLink: {
                    list: [],
                    other: ''
                },
                handleSpecialProcess: {
                    list: [],
                    other: ''
                },
                mainQuantityStr: {
                    list: []
                },
                canBuyFabricAbility: '',
                capcity: '',
                favoriteArea: '',
                employeeData: {
                    total: "",
                    childrenLists: [{
                        name: "",
                        num: "",
                    }]
                },
                machineData: {
                    total: "",
                    childrenLists: [{
                        name: "",
                        num: "",
                    }]
                }
            },
            qualitySelect: '', // 产品输出

            // employeeData: {
            //     total: "",
            //     childrenLists: [{
            //         name: "",
            //         num: "",
            //     }]
            // },
            // machineData: {
            //     total: "",
            //     childrenLists: [{
            //         name: "",
            //         num: "",
            //     }]
            // }
        }
    },
    computed: {
        ...mapGetters(['userId', 'userIsAuth', 'userInfo']),
        companyImage: function() {
            return this.userInfo.picturesTakenInFactories.map(item => api.imgPrev + item.image_file)
        },
        employeeDataList() {
            if (this.submitForm.employeeData) {
                return this.submitForm.employeeData.childrenLists || []
            } 
            return []
        },
        machineDataList() {
            if (this.submitForm.machineData) {
                return this.submitForm.machineData.childrenLists || []
            } 
            return []
        },
    },
    created() {
    },
    methods: {
        // 打开编辑
        editFormHandle(keyName) {
            this.editForm[keyName] = true
            if (keyName === 'clothesData') {
                this.submitForm.clothesData = JSON.parse(JSON.stringify(this.userInfo.mainTypeLists))
            }
            if (keyName === 'handleNeedProcessingLink') {
                this.submitForm.handleNeedProcessingLink = JSON.parse(JSON.stringify(this.userInfo.handleNeedProcessingLink))
            }
            if (keyName === 'handleSpecialProcess') {
                this.submitForm.handleSpecialProcess = JSON.parse(JSON.stringify(this.userInfo.handleSpecialProcess))
            }
            if (keyName === 'mainQuantityStr') {
                this.submitForm.mainQuantityStr = JSON.parse(JSON.stringify(this.userInfo.mainQuantityStr))
                this.qualitySelect = this.submitForm.mainQuantityStr.list.filter(item => item.isSelect == 1)[0].dataName
            }
            if (keyName === 'canBuyFabricAbility') {
                this.submitForm.canBuyFabricAbility = this.userInfo.canBuyFabricAbility
            }
            if (keyName === 'capcity') {
                this.submitForm.capcity = this.userInfo.capcity
            }
            if (keyName === 'favoriteArea') {
                this.submitForm.favoriteArea = this.userInfo.favoriteArea
            }

            if (keyName === 'employeeData') {
                this.submitForm.employeeData = {
                    total: this.userInfo.employeeData.total,
                    childrenLists: this.userInfo.employeeData.childrenLists.map((item, index) => ({
                        key: Math.random(),
                        name: item.name,
                        num: item.num,
                    }))
                }
            }

            if (keyName === 'machineData') {
                this.submitForm.machineData = {
                    total: this.userInfo.machineData.total,
                    childrenLists: this.userInfo.machineData.childrenLists.map((item, index) => ({
                        key: Math.random(),
                        name: item.name,
                        num: item.num,
                    }))
                }
            }
            
        },

        // 提交编辑
        submitFormHandle(keyName) {
            this.$refs[keyName].validate((valid) => {
                if (valid) {
                    // console.log('pass')
                    let params1 = {
                        product: this.userInfo.mainTypeLists,
                    }
                    let params2 = {
                        handleNeedProcessingLink: this.userInfo.handleNeedProcessingLink,
                        handleSpecialProcess: this.userInfo.handleSpecialProcess,
                        mainQuantityStr: this.userInfo.mainQuantityStr,
                        canBuyFabricAbility: this.userInfo.canBuyFabricAbility,
                        staffsNumber: this.userInfo.staffsNumber,
                        favoriteArea: this.userInfo.favoriteArea,
                        capcity: this.userInfo.capcity,
                    }
                    if (keyName === 'clothesData') {
                        params1.product = this.submitForm.clothesData
                    }
                    if (keyName === 'handleNeedProcessingLink') {
                        params2.handleNeedProcessingLink = this.submitForm.handleNeedProcessingLink
                    }
                    if (keyName === 'handleSpecialProcess') {
                        params2.handleSpecialProcess = this.submitForm.handleSpecialProcess
                    }
                    if (keyName === 'mainQuantityStr') {
                        params2.mainQuantityStr = this.submitForm.mainQuantityStr
                    }
                    if (keyName === 'canBuyFabricAbility') {
                        params2.canBuyFabricAbility = this.submitForm.canBuyFabricAbility
                    }
                    if (keyName === 'capcity') {
                        params2.capcity = this.submitForm.capcity
                    }
                    if (keyName === 'favoriteArea') {
                        params2.favoriteArea = this.submitForm.favoriteArea
                    }
                    console.log(params1,'params1')
                    console.log(params2,'params2')
                    let arg={
                        userId: this.userId,
                        regStr: JSON.stringify(params1),
                        staffDevice: JSON.stringify(params2)
                    }
                    console.log(arg,'arg')
                    request({
						url: api.editExtraUserInfo,
						data: arg
                    }).then(res => {
                        if (res.errorCode == 200) {
                            this.$store.dispatch('getUserInfo')
                            this.editForm[keyName] = false
                        } else {
                            this.$message.error(res.errorMsg || '编辑失败')
                        }
                    }).catch(err => {
                        console.log(err)
                    })

                }
            })
        },

        editNumFormHandle(keyName) {
            this.$refs[keyName].validate((valid) => {
                if (valid) {
                    // console.log('pass')
                    let params = {
                        employeeData: this.userInfo.employeeData,
                        machineData: this.userInfo.machineData,
                    }
                    if (keyName === 'employeeData') {
                        params.employeeData = {
                            total: this.submitForm.employeeData.total,
                            childrenLists: this.submitForm.employeeData.childrenLists.map(item => ({
                                name: item.name,
                                num: item.num
                            }))
                        }
                    }

                    if (keyName === 'machineData') {
                        params.machineData = {
                            total: this.submitForm.machineData.total,
                            childrenLists: this.submitForm.machineData.childrenLists.map(item => ({
                                name: item.name,
                                num: item.num
                            }))
                        }
                    }
                    // console.log(params)
                    
                    request({
						url: api.addStaffDevice,
						data: {
							userId: this.userId,
                            staffInfo: JSON.stringify(params)
                        }
                    }).then(res => {
                        if (res.errorCode == 200) {
                            this.$store.dispatch('getUserInfo')
                            this.editForm[keyName] = false
                        } else {
                            this.$message.error(res.errorMsg || '编辑失败')
                        }
                    }).catch(err => {
                        console.log(err)
                    })

                }
            })
        },
        
        // 自定义校验函数
        validateClothesData(rule, value, callback) {
            if (this.submitForm.clothesData.some(item => item.checked)) {
                callback()
            } else {
                callback(new Error('请选择您的主营品类'))
            }
        },
        // 选择主营品类
        changeClothesTag() {
            this.checkClothesData('clothesData', 'clothesData')
        },
        // 主营品类 - 数据调整、校验
        checkClothesData(dataName, validName) {
            this.submitForm[dataName].forEach(item => {
                item.checked = item.list.some(ele => ele.checked)
            })
            this.$refs[dataName].validateField(validName)
        },

        // 校验您所能处理的加工环节
        validateHandleNeedProcessingLink(rule, value, callback) {
            let data = this.submitForm.handleNeedProcessingLink
            if (data.list.some(item => item.isSelect == '1') || data.other) {
                callback()
            } else {
                callback(new Error('请选择您所能处理的加工环节'))
            }
        },
        // 选择您所能处理的加工环节
        selectHandleNeedProcessingLink(e, item) {
            e ? item.isSelect = '1' : item.isSelect = '0'
            this.$refs['handleNeedProcessingLink'].validateField('handleNeedProcessingLink')
        },

        // 校验您所能处理的特殊工艺
        validateHandleSpecialProcess(rule, value, callback) {
            let data = this.submitForm.handleSpecialProcess
            if (data.list.some(item => item.isSelect == '1') || data.other) {
                callback()
            } else {
                callback(new Error('请选择您所能处理的加工环节'))
            }
        },
        // 选择您所能处理的特殊工艺
        selectHandleSpecialProcess(e, item) {
            e ? item.isSelect = '1' : item.isSelect = '0'
            this.$refs['handleSpecialProcess'].validateField('handleSpecialProcess')
        },

        // 校验您的主要品质产出
        validateMainQuantityStr(rule, value, callback) {
            let data = this.submitForm.mainQuantityStr
            if (data.list.some(item => item.isSelect == '1')) {
                callback()
            } else {
                callback(new Error('请选择您所能处理的加工环节'))
            }
        },
        // 选择您的主要品质产出
        selectMainQuantityStr(e, item) {
            this.submitForm.mainQuantityStr.list.forEach(item => {
                item.dataName == e ? item.isSelect = '1' : item.isSelect = '0'
            })
            this.$refs['mainQuantityStr'].validateField('mainQuantityStr')
        },

        // 员工数
        addEmployeeData() {
            this.submitForm.employeeData.childrenLists.push(
                {
                    key: Math.random(),
                    name: "",
                    num: "",
                }
            )
        },
        delEmployeeData(item, index) {
            this.submitForm.employeeData.childrenLists.splice(index, 1)
        },
        validateEmployeeData(rule, value, callback) {
            if (this.submitForm.employeeData.total === '' ||
                this.submitForm.employeeData.childrenLists.some(item => item.name === '' || item.num === '')
            ) {
                callback(new Error('输入框不能为空，请填写'))
            } else {
                callback()
            }
        },

        // 设备数
        addMachineData() {
            this.submitForm.machineData.childrenLists.push(
                {
                    key: Math.random(),
                    name: "",
                    num: "",
                }
            )
        },
        delMachineData(item, index) {
            this.submitForm.machineData.childrenLists.splice(index, 1)
        },
        validateMachineData(rule, value, callback) {
            if (this.submitForm.machineData.total === '' ||
                this.submitForm.machineData.childrenLists.some(item => item.name === '' || item.num === '')
            ) {
                callback(new Error('输入框不能为空，请填写'))
            } else {
                callback()
            }
        }
      
    }
}
</script>
<style lang="scss" scoped>
.fac-table-wrap {
    margin-top: 44px;
    padding: 0 0 0 24px;
    .title-wrap {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 0 24px;
        .tit {
            font-size: 16px;
            font-weight: 500;
            color: rgba(0, 0, 0, 0.85);
            line-height: 24px;
        }
    }
    .table-container {
        width: 100%;
        overflow-y: hidden;
        overflow-x: auto;
    }
    .table {
        margin-top: 24px;
        min-width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
        th {
            background: #fafafa;
            height: 40px;
            border: 1px solid #F0F0F0;
        }
        td {
            text-align: center;
            height: 40px;
            min-width: 100px;
            border: 1px solid #F0F0F0;
        }
    }
}
.edit-table-wrap {
    width: 484px;
    text-align: right;
    .add {margin-bottom: 8px;}
}
.edit-table {
    text-align: center;
    border-collapse: collapse;
    border-spacing: 0;
    th, td {
        border: 1px solid #eee;
        padding: 8px;
    }
    th {
        background: #fafafa;
        padding: 0px 8px;
    }
    &.sum {
        margin-top: 24px;
        td {
            width: 200px;
        }
    }
}

</style>